module.exports = __webpack_public_path__ + "static/media/socket.96552f6a.svg";